import React from 'react';

import './BookendsHeader.scss';

const VISTAPRINT_URL = 'https://www.vistaprint.com';

const VistaprintHeader: React.FC = () => {
  return (
    <div className="bookends-header">
      <a href={VISTAPRINT_URL} className="bookends-header-logo-link">
        <img
          src={`${window.vbcConfig.host}/vistaprint-512.png`}
          alt="Vistaprint"
          width={48}
          height={48}
          className="bookends-header-logo"
        />
      </a>
    </div>
  );
};

export default VistaprintHeader;
